export enum CMSEditModePosition  {
    before=1,
    up=1,
    after=2,
    down=2
}
